import React from "react"

import {
  Seo,
  Header,
  Layout,
  About,
  Special,
  ContactForm,
  ReviewAndInsta,
  Gallery,
} from "components"

const IndexPage = () => (
  <Layout>
    <Seo title="Home" />
    <Header />
    <About />
    <Special />
    <ReviewAndInsta />
    <Gallery />
    <ContactForm />
  </Layout>
)

export default IndexPage
